import request from '@/utils/request'

//验证码登录
export function loginCode(mobile, code, source) {
  const data = {
    mobile,
    code,
    source: source || null
  }
  return request({
    url: '/member/auth/sms-login',
    method: 'post',
    headers: {
      isToken: false
    },
    data: data
  })
}

//密码登录
export function login(mobile, password) {
  const appAuthLoginReqVO = {
    mobile,
    password
  }
  return request({
    url: '/member/auth/login',
    method: 'post',
    headers: {
      isToken: false
    },
    data: appAuthLoginReqVO
  })
}

//密码登录
export function register(fullName, corporateName, phoneNo, verificationCode, source) {
  const data = {
    fullName,
    corporateName,
    mobile: phoneNo,
    code: verificationCode,
    source: source || null
  }
  return request({
    url: '/member/auth/sms-login',
    method: 'post',
    headers: {
      isToken: false
    },
    data: data
  })
}

//修改密码
export function updateForget(appMemberUserUpdatePasswordReqVO) {
  return request({
    url: '/member/user/update-password',
    method: 'put',
    data: appMemberUserUpdatePasswordReqVO
  })
}

//忘记密码
export function resetPassword(data) {
  return request({
    url: '/member/user/reset-password',
    method: 'put',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/member/user/get',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/member/auth/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCode(phoneNo) {
  const data = {
    mobile: phoneNo,
    scene: 1
  }
  return request({
    url: '/member/auth/send-sms-code',
    method: 'post',
    headers: {
      isToken: false
    },
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js